import React, { useState } from 'react';
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  TableRow,
  Tooltip,
  Typography,
  TableHead,
  TableContainer,
  FormControlLabel,
  FormGroup,
  TableBody,
  Table,
  Box,
  Chip,
  Avatar,
  tableCellClasses,
  TablePagination,
  IconButton,
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FlagIcon from '@mui/icons-material/Flag';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {
  StyledTableCell,
  StyledTableRow,
  styleimg,
  stylename,
  styleRate,
  styleRating,
} from './CommonTableStyle';
import {
  IOSSwitch,
  StyledCheckbox,
} from 'pages/configuration/addCompliance/AddComplianceStyleTab';
import ProgressBar from 'components/progressBar/ProgressBar';
import { dateFormate, getTimeFormat, truncateComment } from 'utils/utils';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import editmore from 'assets/images/moreEditIcon.svg';
import deleteicon from 'assets/images/delete.svg';
import deactivate from 'assets/images/deactivateicon.svg';
import block from 'assets/images/block.svg';
import starImg from 'assets/images/smStar.svg';
import profile from 'assets/images/profileImg.svg';
import { wrap } from 'lodash';
import Copy from 'assets/images/copy.svg'
import activate from 'assets/images/CheckSquare.svg'
import DownloadIcon from '@mui/icons-material/Download';
import { CircularProgress } from "@mui/material";
import FileUpload from 'assets/images/fileUpload.svg';
import labelIcon from 'assets/images/labelIcon.svg';
import PlacardModal from 'components/placardModal/PlacardModal';
import upgradeIcon from 'assets/images/upgrade.svg';
import './CommonTable.scss'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import CardMembershipRoundedIcon from '@mui/icons-material/CardMembershipRounded';
import RepeatOnRoundedIcon from '@mui/icons-material/RepeatOnRounded';

export default function CommonTable(props) {
  const { page, rowsPerPage, moreIconData, showPagination = true, tabValue } = props;
  // Ensure data is properly structured
  const safeData = {
    header: Array.isArray(props?.data?.header) ? props?.data?.header : [],
    body: Array.isArray(props?.data?.body) ? props?.data?.body : [],
    totalCount: props?.data?.totalCount || 0
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedTripId, setSelectedTripId] = useState("");

  const handleChangePage = (event, newPage) => {
    props.handleChangePage(event, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event);
  };

  const handleMenuOpen = (event, row) => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePreviewOpen = (placardText, id, e) => {
    e.stopPropagation();
    if (placardText) {
      setSelectedTripId(id);
      setPreviewModal(true);
    }
  };

  const handlePreviewClose = () => {
    setSelectedImage("");
    setPreviewModal(false);
  };

  const onClickTableVendor = (val) => {
    if (props?.from) {
      props?.onClickId(val, props?.from);
    } else {
      props?.onClickTableVendor(val);
    }
  };

  const getRideTypeName = (type) => {
    switch (type.toString()) {  // Convert to string to ensure consistent comparison
      case '1':
        return 'One Way';
      case '3':
        return 'Rental';
      case '4':
        return 'Airport';
      case '9':
        return 'Outstation Round';
      case '8':
        return 'Outstation';
      default:
        return type;
    }
  };

  const getConditionalMenuItems = (status, row) => {
    if (props?.tabName === 'cabCategory' || props?.tabName === 'feedback') {
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Deactivate'];
        case 'inactive':
          return ['Activate'];
        case 'blocked':
          return ['Unblock'];
        default:
          return ['Edit'];
      }
    } else if (props.tabName === 'vehicle') {
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Deactivate', 'Upload Compliance'];
        case 'inactive':
          return ['Activate'];
        case 'blocked':
          return ['Unblock'];
        case 'pending':
          return ['Upload Compliance'];
        default:
          return ['Edit', 'Upload Compliance'];
      }
    } 
   else if (props.tabName === 'driver') {
    switch (status?.toLowerCase()) {
      case 'active':
        return ['Edit', 'Deactivate', 'Upload Compliance', 'Block'];
      case 'inactive':
        return ['Activate', 'Block'];
      case 'blocked':
        return ['Unblock'];
      case 'pending':
        return ['Upload Compliance'];
      default:
        return ['Edit', 'Upload Compliance'];
    }
  }
    else if (props?.tabName === "compliance") {
      return ["Edit"]
    } else if (props?.tabName === 'unAssignTab') {
      return ['Reassign', 'Unassign']
    } else if (props?.tabName === 'rideTrack') {
      switch (status?.toLowerCase()) {
        case 'ongoing':
          return ['Update Status'];
        case 'closed':
          return ['Update Status'];
        default:
          return [];
      }
    } else if (props.tabName === 'coupon') {
      switch (status?.toLowerCase()) {
        case 'active':

          const options = ['Deactivate', 'Delete', 'Copy Coupon']
          if (row.isBanner) {
            options.push('+ Add to highlight')
          }
          return options;

        case 'inactive':
          return ['Edit', 'Activate', 'Copy Coupon', 'Delete'].filter(item =>
            item !== 'Edit' || row?.isDraft
          );
        case 'draft':
          return ['Edit', 'Copy Coupon', 'Delete']
        default:
          return ['Edit', 'Copy Coupon', 'Delete'].filter(item =>
            item !== 'Edit' || row?.isDraft
          );
      }
    } else {
      switch (status?.toLowerCase()) {
        case 'active':
          if (props?.tabName === 'customer') {
            return ['Block'];
          } else {
            return ['Edit', 'Deactivate', 'Block'];
          }
        case 'inactive':
          return ['Activate', 'Block'];
        case 'blocked':
          return ['Unblock'];
        case 'pending':
          if (props?.tabName === 'customer') {
            return []
          } else {
            return ['Edit'];
          }
        default:
          return [];
      }
    }
  };

  const onClickMoreIcon = (event, data, type) => {
    event.preventDefault()
    event.stopPropagation()
    props?.onClickMoreIcon(data, type);
    handleMenuClose();
  };

  const onCheckChange = (e, ele, key, id) => {
    props?.onCheckChange(ele, key, id)

  }

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case 'blocked': case 'block': case 'unblock':
        return block;
      case 'edit':
        return editmore;
      case 'deactivate':
        return deactivate;
      case 'activate':
        return activate;
      case 'delete':
        return deleteicon;
      case 'copy coupon':
        return Copy;
      case 'upload compliance':
        return FileUpload;
      case 'update status':
        return editmore;
      default:
        return;
    }
  };
  const tableHeadKey = (className, key) => {
    if (className) {
      return 'iconColumn';
    }
    else if (key === 'dropping' ||
      key === 'pickup' ||
      key === 'description' ||
      key === 'comment') {
      return 'font14'
    }
    else {
      return ''
    }
  }
  const tableBodyKey = (key) => {
    if (key === 'comment' || key === 'description') {
      return 'font14 fontNormal colorGrey'
    }
    else if (key === 'location') {
      return 'fontNormal'
    }
    else if (key === 'dropping' || key === 'pickup') {
      return 'font14 fontNormal'
    }
  }

  function BannerIcon({ size = 24, color = "currentColor", className = "" }) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{ "marginLeft": "8px" }}
      >
        {/* Banner rectangle */}
        <rect x="2" y="6" width="20" height="12" rx="2" stroke={color} strokeWidth="2" fill="none" />

        {/* Banner content lines */}
        <line x1="6" y1="10" x2="18" y2="10" stroke={color} strokeWidth="1.5" strokeLinecap="round" />

        <line x1="6" y1="14" x2="14" y2="14" stroke={color} strokeWidth="1.5" strokeLinecap="round" />

        {/* Banner flag/ribbon effect */}
        <path d="M22 6L20 8L22 10V6Z" fill={color} stroke={color} strokeWidth="1" strokeLinejoin="round" />
      </svg>
    )
  }

  return (
    <div>
      <TableContainer className="tableMain"  sx={{
          width: '100%'
        }}>
        <Table
          sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: 'none' }, 
            width: '100%' }}
          aria-label="customized table"
        >
          <TableHead className="tableborder">
            <TableRow className="commonTableRow">
              {safeData.header.map((ele) => (
                <StyledTableCell
                  key={ele.label || Math.random()}
                  align="left"
                  className={`comColumnWidth font14 fontMedium ${tableHeadKey(ele.className, ele.key)}`}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {ele.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tableBodyStyle">
            {safeData.body.length > 0 ? (
              safeData.body.map((ele, id) => (
                <StyledTableRow
                  key={ele.id || id}
                  onClick={() => props?.isClickable ? onClickTableVendor(ele) : undefined}
                  disabled={ele.status === 'Blocked'}
                  className={`${props?.isClickable ? 'cursor clickableRow' : 'cursorDefault'} ${ele.gender === "Female" ? 'bgFemale' : ''}`}
                >
                  {safeData.header.map((val, idx) => (
                    <StyledTableCell
                      align="left"
                      key={`${ele.id}-${val.label || idx}`}
                      disabled={ele.status === 'Blocked'}
                      className={`comRowChildWidth ${tableBodyKey(ele.key)}`}
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {val.key === 'title' ? (
                        <Box style={styleimg}>
                          <Tooltip 
                            title={ele[val.key]} 
                            placement="top"
                            arrow
                          >
                            <span style={{ cursor: 'pointer' }}>
                              {ele[val.key]?.length > 10 
                                ? `${ele[val.key].substring(0, 10)}...` 
                                : ele[val.key]
                              }
                            </span>
                          </Tooltip>
                          {/* Show banner icon if it's a banner */}
                          {ele?.isBanner && (
                            <Tooltip title="Banner Coupon" placement="top">
                              <BannerIcon size={20} color="#3B82F6" />
                            </Tooltip>
                          )}
                          {/* Show draft indicator */}
                          {(ele?.status == "Draft") && (
                            <Chip
                              label="Draft"
                              size="small"
                              sx={{
                                marginLeft: '8px',
                                backgroundColor: '#E5E7EB',
                                color: '#4B5563',
                                fontWeight: 500
                              }}
                            />
                          )}
                        </Box>
                      ) : val.key === 'type' ? (
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography
                              sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontSize: '14px',
                                fontWeight: 500
                              }}
                            >
                              {getRideTypeName(ele[val.key])}
                            </Typography>

                            {/* Show recurring icon for requested, scheduled, assigned, and cancelled tabs */}
                            {['requested', 'scheduled', 'assigned', 'cancelled'].includes(tabValue) && ele?.additionalInfo?.isRecurring && (
                              <Tooltip title="Recurring Trip" placement="bottom">
                                <RepeatOnRoundedIcon
                                  sx={{
                                    fontSize: 18,
                                    color: '#0288d1'
                                  }}
                                />
                              </Tooltip>
                            )}
                          </Box>
                      ) : val.key === ele['imageflag'] ? (
                        <Box
                          style={styleimg}
                        >
                          {val.key === ele['imageflag'] && (
                            <img
                              style={stylename}
                              className="width33"
                              src={ele?.avtar?.url ? ele?.avtar?.url : profile}
                              alt="vendorimage"
                            />
                          )}
                          <span>
                            <Tooltip title={ele[val.key]} placement="bottom">
                              {truncateComment(ele[val.key], 20)}
                            </Tooltip> <br />
                            {ele?.category && (
                              <span className="font12 fontNormal colorGrey">
                                {ele.category}
                              </span>
                            )}
                          </span>
                          {/* show active subscription icon when this cell represents the name */}
                          {ele?.hasActiveSubscription && val.key === 'name' && (
                            <Tooltip title="Active Subscription" placement="top">
                              <WorkspacePremiumOutlinedIcon
                                sx={{
                                  fontSize: 20,
                                  color: '#0F538D',
                                  marginLeft: '8px'
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                      ) : val.key === 'walletPoints' ? (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <AccountBalanceWalletIcon sx={{ color: '#FFD700', fontSize: 20 }} />
                            <span>
                              {ele?.walletPoints?.currentBalance ?? 0}
                            </span>
                          </Box>
                        ) : val.key === 'rating' ? (
                        <Box style={styleimg}>
                          {ele[val.key] && ele[val.key] !== null && <img
                            src={starImg}
                            alt="vendorimage"
                            className="width16"
                            style={stylename}
                          />}
                          <span className="fontWeight400">{ele[val.key]}</span>
                        </Box>
                      ) : val.key === 'documentname' ? (
                        <Box style={styleimg}>
                          {ele.star && (
                            <img
                              src={ele.star}
                              alt="vendorimage"
                              className="feedbackStar"
                            />
                          )}
                          <div style={styleRate}>{ele[val.key]}</div>
                          <div style={styleRating}>{ele.ratingmsg}</div>
                        </Box>
                      ) : val.key === 'starValue' ? (
                        <Box style={styleimg}>
                          <img
                            src={starImg}
                            alt="vendorimage"
                            className="width16"
                            style={stylename}
                          />
                          <span className="fw600">{ele[val.key] ? ele[val.key] : 0}</span>
                          <span>&nbsp;Rating</span>
                        </Box>
                      ) : val.key === ele['currencyFlag'] ? (
                        <Box className={ele['currencyFlag'] === 'price' ? "w100" : null}>
                          <span >
                            <Tooltip title={'₹ ' + ele[val.key]} placement="bottom">
                              {ele['currencyFlag'] === 'price' ? truncateComment('₹ ' + ele[val.key], 8) : '₹ ' + ele[val.key]}
                            </Tooltip></span>
                        </Box>
                      ) : val.key === 'carType' ? (
                        <Box>
                          <div className="flex items-center gap-2">
                          {ele?.additionalInfo?.isUpgrade && <Tooltip title="Upgraded"
                            placement="bottom-start"><img src={upgradeIcon} alt="upgradeIcon" className="w-8 h-8" /></Tooltip>}
                            <div>
                              <div>{ele[val.key]}</div>
                              <div className='font12 colorGrey'>{ele.regNumber}</div>
                            </div>
                          </div>
                        </Box>
                      ) : val.key === 'documentStatus' ? (
                        <Box>
                          <div className="progressAlign">
                            <span className="tableProgressBar">
                              <ProgressBar
                                approvedCount={ele?.ApprovedCount}
                                rejectCount={ele?.rejectCount}
                                totalRequired={ele?.totalRequired}
                              />
                            </span>
                            <span className="tableProgressBarText">
                              {ele[val.key]}
                            </span>
                          </div>
                        </Box>
                      ) : val.key === 'comment' ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 20)}
                        </Tooltip>
                      ) : val.key === 'email' ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                        </Tooltip>
                      ) : (ele['pickup'] === val.key || val.key === 'sourceAddress') ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                          {/* // TODO: below we dont need to show same time and date */}
                          {ele?.tripStartTime && (
                            <div className="font10 colorGrey">
                              {dateFormate(ele['tripStartTime'], 'DD MMM YYYY, hh:mm a')}
                            </div>
                          )}
                        </Tooltip>
                      ) : (ele['drop'] === val.key || val.key === 'destinationAddress') ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                          {ele?.completedAt && (
                            <div className="font10 colorGrey">
                              {dateFormate(ele['completedAt'], 'DD MMM YYYY, hh:mm a')}
                            </div>
                          )}
                        </Tooltip>
                      ) : val.label === "Rep. Time" ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {dateFormate(ele['tripStartTime'], 'DD MMM YYYY, hh:mm a')}
                          </Typography>
                        </Box>
                      ) : val.key === 'joinDate' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY')
                      ) : val.key === 'updatedAt' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY')
                      ) : val.key === 'createdAt' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                      ) : val.key === 'completedAt' ? (
                        dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : val.key === 'expiresAt' ? (
                          dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : val.key === 'tripScheduledTime' ? (
                          dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : val.key === 'scheduledTime' ? (
                          dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ): val.key === 'tripDate' ? (
                          dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : val.key === 'tripStartTime' ? (
                         dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : val.key === 'tripEndTime' ? (
                         dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : val.key === 'expiryDate' ? (
                          dateFormate(ele[val.key], 'DD MMM YYYY, hh:mm a')
                        ) : (val.key === 'status' && !ele.reportStatus) ? (
                          <Typography
                            className={`textTransformInherit textCaptialize fontNormal ${ele?.status + 'Btn'
                              }`}
                            variant="contained"
                            disabled={ele.status === 'Blocked'}
                          >
                            {ele[val.key]}
                          </Typography>
                        ) : val.key === 'action' && props?.assignBtnAccess ? (
                          <Button
                            className={`textTransformInherit fontNormal ${ele.action + 'Btn'
                              }`}
                            variant="contained"
                            onClick={() => { onClickTableVendor(ele) }}
                          >
                            {ele[val.key]}
                          </Button>
                        ) : val.key === 'icon' && !props?.viewMoreIcon && (!ele['hideaction']) ? (
                          (getConditionalMenuItems(ele?.status, ele).length > 0 ? ( <div className='floatRight'>
                            <IconButton
                              onClick={(event) => handleMenuOpen(event, ele)}
                            >
                              <div className="colorBlack">{<MoreVertIcon />}</div>
                            </IconButton>
                          </div>) : null)
                        ) : val.key === 'amount' &&
                          props.from === 'dashboardRide' ? (
                          <Grid>
                            <div>{ele[val.key]}</div>
                            {ele?.status && (
                              <div className={`font12 ${ele.status + 'Btn'}`}>
                                {ele['status']}
                              </div>
                            )}
                          </Grid>
                        ) : val.key === 'pickup' && props.from === 'rideTrack' ? (
                          <Grid>
                            <div>{ele[val.key]}</div>
                            {ele?.pickupDate && (
                              <div className="font10 colorGrey">
                                {ele['pickupDate']}
                              </div>
                            )}
                          </Grid>
                        ) : val.key === 'car' && props.from === 'rideTrack' ? (
                          <Grid>
                            <div>{ele[val.key]}</div>
                            {ele?.pickupDate && (
                              <div className="font10 colorGrey">
                                {ele['carNumber']}
                              </div>
                            )}
                          </Grid>
                        ) : val.key === 'isActive' ? (
                          <FormGroup className="switchButton">
                            <FormControlLabel
                              control={<IOSSwitch checked={ele[val.key]} onChange={(e) => { onCheckChange(e, ele, val.key, id) }} />}
                            />
                          </FormGroup>
                        ) : (val.key === 'isMandatory') ? (
                          <StyledCheckbox checked={ele[val.key]} onChange={(e) => { onCheckChange(e, ele, val.key, id) }} />
                        ) : (val.key === 'isExpiring') ? (
                          <StyledCheckbox checked={ele[val.key]} onChange={(e) => { onCheckChange(e, ele, val.key, id) }} />
                        ) : (val.key === 'tags') ? (
                          (() => {
                            const tags = Array.isArray(ele[val.key])
                              ? ele[val.key]
                              : typeof ele[val.key] === "string"
                              ? ele[val.key]
                                  .split(",")
                                  .map((tag) => tag.trim())
                                  .filter(Boolean)
                              : [];

                            return tags.map((tag, idx) => (
                              <Chip
                                key={idx}
                                label={tag}
                                size="small"
                                style={{
                                  marginRight: 4,
                                  backgroundColor: '#e0e0e0',
                                  color: '#888',
                                  fontWeight: 500,
                                }}
                              />
                            ));
                          })()
                        ) : (val.key === 'Facilities') ? (
                          <Box>
                            {ele?.Facilities?.map((data) => (
                              <Chip
                                key={data.id}
                                className='chipSizeStyle'
                                avatar={<Avatar alt="Natacha" src={data?.img?.url} />}
                                label={data?.name}
                                variant="outlined"
                              />
                            ))}
                          </Box>
                        ) : val.key === 'customerName' ? (
                          <Box display="flex" alignItems="center" gap={1}>
                              <Tooltip title={ele[val.key]} placement="bottom">
                                <Typography
                                  sx={{
                                    fontSize: '14px',
                                    fontWeight: 500
                                  }}
                                >
                                  {ele[val.key]}
                                </Typography>
                              </Tooltip>
                              {ele?.additionalInfo?.placard?.text && (
                                <Tooltip title="View Placard" placement="bottom">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevent row click
                                    handlePreviewOpen(
                                      ele?.additionalInfo?.placard?.text,
                                      ele?.id,
                                      e
                                    );
                                  }}
                                  sx={{ padding: '4px' }}
                                >
                                  <img 
                                    src={labelIcon} 
                                    alt="Placard"
                                    style={{ 
                                      width: '20px',
                                      height: '20px'
                                    }}
                                  />
                                </IconButton>
                                </Tooltip>
                              )}
                            {ele.complainType === "sos" && (
                              <span className="inline-flex px-[10px] py-[4px] justify-center items-center gap-[10px] rounded-[8px] bg-[#F2C7C7] text-[#950000] font-openSans text-[12px] font-normal leading-none">
                                SOS
                              </span>
                            )}
                          </Box>
                        ) : val.key === 'reportName' ? (
                          <Tooltip title={ele[val.key]} placement="bottom" arrow>
                            <Typography
                              sx={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                fontSize: '14px',
                                fontWeight: 400,
                                lineHeight: 1.4
                              }}
                            >
                              {ele[val.key]}
                            </Typography>
                          </Tooltip>
                        ) : val.key === 'category' ? (
                        <Tooltip title={ele[val.key]} placement="bottom" arrow>
                        <Typography
                          sx={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            fontSize: '14px',
                            lineHeight: 1.4
                          }}
                        >
                          {ele[val.key]}
                        </Typography>
                        </Tooltip>
                      ) :
                        val.key === 'errorMessage' ? ( // ✅ Show NA if null
                          ele[val.key] ? ele[val.key] : "--"
                        ) : (val.key === 'downloadLink' && ele[val.key] && ele[val.key].trim() !== '') ? (
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (ele.downloadLink) {
                                window.open(ele.downloadLink, '_blank');
                              }
                            }}
                          >
                            <DownloadIcon />
                          </IconButton>
                        ) : val.key === 'status' ? (
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography
                              className={`textTransformInherit textCaptialize fontNormal ${ele?.status + 'Btn'}`}
                              variant="contained"
                              disabled={ele.status === 'Blocked'}
                              sx={{ color: ele?.status === 'InActive' ? '#ffa726' : 'inherit'}}
                            >
                              {ele.status}
                            </Typography>
                            {/* Show loader for INPROGRESS/PENDING status */}
                            {ele.showLoader && (
                              <CircularProgress size={16} thickness={4} />
                            )}
                          </Box>
                        ) : val.key === 'placard' ? (
                          <Box 
                            sx={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              gap: 1,
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent row click
                              if (ele?.additionalInfo?.placard?.text) {
                                handlePreviewOpen(ele?.additionalInfo?.placard, e);
                              }
                            }}
                          >
                            <Typography variant="body2" sx={{ mr: 1 }}>
                              {ele?.tripId}
                            </Typography>
                            {ele?.additionalInfo?.placard?.text && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent row click
                                  handlePreviewOpen(ele?.additionalInfo?.placard?.text, e);
                                }}
                              >
                                <img 
                                  src={labelIcon} 
                                  alt="Placard"
                                  style={{ 
                                    width: '20px',
                                    height: '20px'
                                  }}
                                />
                              </IconButton>
                            )}
                          </Box>
                        ) : val.key === 'tripId' ? (
                          props?.tabName === 'rideTrack' ? (
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography variant="body2">
                                {ele?.tripId}
                              </Typography>
                              {ele?.additionalInfo?.isRecurring && (
                                <Tooltip title="Recurring Trip" placement="bottom">
                                  <RepeatOnRoundedIcon
                                    sx={{
                                      fontSize: 18,
                                      color: '#0288d1'
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          ) : (
                            <Typography variant="body2">
                              {ele?.tripId}
                            </Typography>
                          )
                        ) : val.key === "daysToExpire" ? (
                          ele[val.key] < 0 
                            ? <Typography color="error">Expired</Typography>
                            : <Typography className="colorOrangeText">{ele[val.key]} days</Typography>
                        ) : (
                            // Default case for other fields
                            ele[val.key]
                          )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={safeData.header.length || 1} align="center">
                  <CommonNoDataFound />
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {showPagination && safeData.body.length > 0 && safeData.totalCount > 10 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={safeData.totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(
          anchorEl && selectedRow?.id === selectedRow.id
        )}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {moreIconData && moreIconData.length > 0
          ? // Render the menu items using moreIconData if it is available
          moreIconData.map((moreData, idx) => (
            <MenuItem
              onClick={(e) =>
                onClickMoreIcon(e, selectedRow, moreData?.name)
              }
              selected={selectedItem === moreData?.name}
              key={moreData?.id}
            >
              {moreIconSrc(moreData?.name)?.length > 0 && (
                <span className="marginRight10 alignItem">
                  <img
                    src={moreIconSrc(moreData?.name)}
                    alt={moreData?.name}
                  />
                </span>)}
              <Typography className="font16 fontSemi">
                {moreData?.name}
              </Typography>
            </MenuItem>
          ))
          : // Render the custom menu items if moreIconData is not available
          getConditionalMenuItems(selectedRow?.status, selectedRow).map(
            (moreData, idx) => (
              <MenuItem
                onClick={(e) =>
                  onClickMoreIcon(e, selectedRow, moreData)
                }
                selected={selectedItem === moreData}
                key={moreData}
              >
                {moreIconSrc(moreData)?.length > 0 && (
                  <span className="marginRight10 alignItem">
                    <img
                      src={moreIconSrc(moreData)}
                      alt={moreData}
                    />
                  </span>)}
                <Typography className="font16 fontSemi">
                  {moreData}
                </Typography>
              </MenuItem>
            )
          )}
      </Menu>
      {previewModal && (
  <PlacardModal
    open={previewModal}
    handleClose={handlePreviewClose}
    tripId={selectedTripId}
  />
)}
    </div>
  );
}
